import React from "react";

export default function Skeleton() {
  let d = [];
  for (let index = 0; index < 10; index++) {
    d.push(index);
  }
  return (
    <div
      className="grid grid-cols-2 gap-1 sm:grid-cols-3 xl:grid-cols-5"
      style={{ margin: "2rem 0", gridAutoRows: "400px" }}
    >
      {d.map((el) => (
        <div className="skeleton" key={el} />
      ))}
    </div>
  );
}
